import React, { useContext, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { Link, useHistory } from 'react-router-dom';
import { Checkbox, Icon, Loader, Modal } from 'semantic-ui-react';
import TextField from '../../OrderEntry/ui/TextField';
import Select from 'react-select';
import { ClientUser, ClientUserSubmitionError, DropdownOption } from '../types';
import axios from 'axios';
import { UserContext, useUserContext } from '../../../context/UserContext';
import produce from 'immer';

const NewUserModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;
const TopPart = styled.div`
  padding: 26px 20px 20px 20px;
  border: 1px solid #e5e5ea;
`;
const Close = styled.button`
  display: flex;
  justify-content: flex-end;
  background-color: #fff;
  border: none;
  cursor: pointer;
`;
const ActualContent = styled.div`
  padding: 30px 24px;
`;
const NewUser = styled.div`
  font-weight: bold;
  font-size: 20px;
  color: #4d4e4d;
`;

const Information = styled.div`
  width: 320.67px;
  height: 48px;
  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  margin-top: 24.25px;
  font-size: 16px;
  line-height: 24px;
  color: #4d4e4d;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 9px;
  margin-top: 45px;
  justify-content: flex-end;
`;

const CancelButton = styled.button`
  background: #ffffff;
  border: 1px solid #e5e5ea;
  box-sizing: border-box;
  border-radius: 5px;
  color: #444444;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  width: 174px;
  height: 48px;
  cursor: pointer;
`;
const AddButton = styled.button`
  background: #444;
  border: 1px solid #444;
  box-sizing: border-box;
  border-radius: 5px;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  color: #ffffff;
  width: 144px;
  height: 46px;
  cursor: pointer;
`;
const customStyles = {
  container: (provided: any, state: any) => ({
    ...provided,
    width: 448,
    marginTop: 8,
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    border: '1px solid #f5f5f5',
    height: 48,
  }),
};
const multiSelectStyles = {
  valueContainer: (provided: any) => ({
    ...provided,
    maxHeight: '200px',
    overflow: 'auto',
    minHeight: 45,
    outline: '1px solid #f4f0ed',
    borderColor: '#f4f0ed',
    border:'1px solid #fff'
  }),
  indicatorsContainer: (provided: any, state: any) => ({
    ...provided,
    outline: '1px solid #f4f0ed',
    borderColor: '#f4f0ed',
    border:'1px solid #fff'
  }),
  multiValue: (provided: any, state: any) => ({
    ...provided,
    borderRadius: '15px',
    border: '1px solid #f5f5f5',
  }),
};
const ErrorText = styled.div`
  font-size: 13px;
  color: #c50e29;
`;
const Overlay = styled.div`
  background-color: rgba(249, 248, 248, 0.5);
  bottom: 0;
  height: 100%;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 10000;
  border-radius:4px;
`;
interface Props {
  afterSaveUser: () => void;
  open: boolean;
  onClose: any;
}

const NewUserModal = (props: Props) => {
  const [loading, setLoading] = useState(false);
  // const [notificationTypes, setNotificationTypes] = useState<DropdownOption[]>([]);
  const [roles, setRoles] = useState<DropdownOption[]>([]);
  const [errors, setErrors] = useState<ClientUserSubmitionError>(null);
  const [newUser, setNewUser] = useState<ClientUser>({
    contactNotificationTypes: [],
    createLogin: false,
    firstName: '',
    lastName: '',
    email: '',
    roleOption: { value: 0, label: '' },
    editedNotificationTypes: true,
  });

  const { user } = useUserContext();

  // const getClientNotificationTypes = async () => {
  //   const { data } = await axios.get('/api/ClientProfile/GetClientNotificationTypes');
  //   const mappedData = data.map(d => ({ value: d.id, label: d.notificationType }));
  //   setNotificationTypes(mappedData);
  // };
  const getRolesForClient = async () => {
    const { data } = await axios.get('/api/ClientProfile/GetRolesForClient');
    const mappedData = data.map(d => ({ value: d.id, label: d.name }));
    setRoles(mappedData);
  };
  const validateForm = () => {
    const errors: ClientUserSubmitionError = {};
    if (!newUser.firstName) {
      errors.firstName = 'First Name Required';
    }
    if (!newUser.lastName) {
      errors.lastName = 'Last Name Required';
    }
    if (!newUser.email) {
      errors.email = 'Email Required';
    }
    const userRole = newUser.roleOption?.value || 0;
    if (newUser.createLogin && userRole === 0) {
      errors.role = 'Role Required';
    }
    setErrors(errors);
    return Object.keys(errors).length === 0 ? null : errors;
  };
  const addNewUser = async () => {
    const err = validateForm();
    if (err) {
      return;
    }

    setLoading(true);
    await axios.post(`/api/ClientProfile/AddClientContact/${user.clientId}`, newUser);
    setLoading(false);
    props.onClose();
    props.afterSaveUser();
  };
  
  const changeUserInfo = (label: keyof Partial<ClientUser>, value: any) => {
    const newUserTemp = produce(newUser, draft => {
      (draft[label] as any) = value;
    });
    setNewUser(newUserTemp);
  };
  useEffect(() => {
    // getClientNotificationTypes();
    getRolesForClient();
  }, []);
  return (
    <Modal open={props.open} style={{  width: 496, zIndex: 500 }} onClose={props.onClose}>
      <NewUserModalContent>
        <TopPart>
          <div style={{display:'flex',justifyContent:'space-between' }}>
          <NewUser>Add New Member</NewUser>
          <Close onClick={props.onClose}>
            <Icon name="close" />
          </Close>
          </div>
        <div style={{fontSize:12, marginTop:10, color:'#8E8E93', width:400, lineHeight:1.3}}>Creating a user account gives you the ability to choose notification preferences for a specific email address.</div>
        </TopPart>
        <ActualContent>
          <div style={{ display: 'flex' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <TextField
                name="name"
                label="First Name"
                width="220"
                value={newUser.firstName || ''}
                onChange={e => changeUserInfo('firstName', e.target.value)}
                styles={{ input: { paddingLeft: 8 }, marginRight: 8 }}
              />
              {errors?.firstName && <ErrorText>{errors?.firstName}</ErrorText>}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <TextField
                name="name"
                label="Last Name"
                width="220"
                value={newUser.lastName || ''}
                onChange={e => changeUserInfo('lastName', e.target.value)}
                styles={{ input: { paddingLeft: 8 } }}
              />
              {errors?.lastName && <ErrorText>{errors?.lastName}</ErrorText>}
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <TextField
              name="email"
              label="Email"
              width="448"
              value={newUser.email || ''}
              onChange={e => changeUserInfo('email', e.target.value)}
              styles={{ input: { paddingLeft: 8 }, marginTop: 24 }}
            />
            {errors?.email && <ErrorText>{errors?.email}</ErrorText>}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', marginTop: 24, position:'relative' }}>
            <Overlay/>
            <div style={{ marginBottom: 8,color:'#e3e1df' }}>Notifications</div>
            <Select
              isMulti
              // options={notificationTypes}
              value={newUser.contactNotificationTypes}
              // onChange={e => changeUserInfo('contactNotificationTypes', e)}
              styles={multiSelectStyles}
              placeholder={''}
              components={{
                IndicatorSeparator: null,
              }}
            />
          </div>
          <div style={{ display: 'flex', marginTop: 36 }}>
            <Checkbox onChange={(e, data) => changeUserInfo('createLogin', data.checked)} />
            <div style={{ paddingLeft: 14, color: '#8E8E93' }}>Create portal login for this user account</div>
          </div>
          {newUser.createLogin &&
          <div style={{ display: 'flex', flexDirection: 'column', marginTop: 36 }}>
            <div>Role</div>
            <Select
              options={roles}
              value={newUser.roleOption || { value: null, label: '' }}
              onChange={e => changeUserInfo('roleOption', e)}
              styles={customStyles}
              placeholder={''}
              components={{
                IndicatorSeparator: null,
              }}
            />
            {errors?.role && <ErrorText>{errors?.role}</ErrorText>}
          </div>
}
          <ButtonContainer>
            <CancelButton onClick={props.onClose}>Cancel</CancelButton>
            <AddButton onClick={addNewUser} disabled={loading}>
              {loading ? <Loader style={{ margin: '0 auto' }} size="mini" inline="centered" /> : 'Add'}
            </AddButton>
          </ButtonContainer>
        </ActualContent>
      </NewUserModalContent>
    </Modal>
  );
};

export default NewUserModal;
